import { useState } from "react";
import { Box, Grid, Typography, useMediaQuery } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const images = [
  { src: "/services_img2.jpg", number: "01", text: "Open Vehicle Transport" },
  { src: "/services_img1.jpg", number: "02", text: "Enclosed Vehicle Transport" },
];

export default function ImageHoverEffect() {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const isMobile = useMediaQuery("(max-width:600px)");

  const handleMouseEnter = (index) => {
    if (!isMobile) setHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    if (!isMobile) setHoveredIndex(null);
  };

  const handleClick = () => {
    const contactForm = document.getElementById("contact-form");
    if (contactForm) {
      contactForm.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Box sx={{ flexGrow: 1, p: 2, width: "90%", margin: "5% auto" }}>
      <Grid container spacing={2} justifyContent="center">
        {images.map((image, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <Box
              sx={{
                position: "relative",
                width: "100%",
                height: "500px",
                overflow: "hidden",
                borderRadius: "8px",
                cursor: "pointer",
              }}
              onMouseEnter={() => handleMouseEnter(index)}
              onMouseLeave={handleMouseLeave}
              onClick={handleClick}
            >
              {/* Image */}
              <img
                src={image.src}
                alt={`Image ${image.number}`}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />

              {/* Overlay */}
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  opacity: hoveredIndex === index ? 1 : 0,
                  transition: "opacity 0.3s ease-in-out",
                }}
              />

              {/* Number on top-left corner */}
              <Typography
                variant="h4"
                sx={{
                  position: "absolute",
                  top: 10,
                  left: 10,
                  color: "white",
                  fontWeight: "bold",
                  opacity: hoveredIndex === index ? 0.8 : 0,
                  transition: "opacity 0.3s ease-in-out",
                }}
              >
                {image.number}
              </Typography>

              {/* Text at bottom-left corner */}
              <Typography
                variant="h6"
                sx={{
                  position: "absolute",
                  bottom: 10,
                  left: 10,
                  color: "white",
                  fontWeight: "bold",
                  opacity: hoveredIndex === index ? 1 : 0.8,
                  transition: "opacity 0.3s ease-in-out",
                  fontFamily: "'Josefin Sans', sans-serif",
                }}
              >
                {image.text}
              </Typography>

              {/* Arrow at bottom-left corner */}
              <Box
                sx={{
                  position: "absolute",
                  bottom: 10,
                  right: 10,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  border: `2px solid ${hoveredIndex === index ? "white" : "darkgray"}`,
                  transition: "border-color 0.3s ease-in-out",
                }}
              >
                <ArrowForwardIcon
                  sx={{
                    color: hoveredIndex === index ? "white" : "darkgray",
                    transition: "color 0.3s ease-in-out",
                  }}
                />
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
